import React, { Component } from 'react'
import { Select, Spin } from 'antd'

const Option = Select.Option

const propTypes = {}

class UserSwitch extends Component {
  renderOptions = () => {
    const { users } = this.props
    let userOptions = ''
    if (users) {
      userOptions = users.map(user => (
        <Option key={user.id} value={user.id}>{`${user.first_name} ${user.last_name}`}</Option>
      ))
    }
    return userOptions
  }

  handleChange = value => {
    const { selectUser } = this.props
    selectUser(value)
  }

  render() {
    const { users } = this.props
    return (
      <Spin spinning={users ? false : true}>
        Filter by user:{' '}
        <Select
          showSearch
          style={{ width: 200 }}
          placeholder="Select a person"
          optionFilterProp="children"
          onChange={this.handleChange}
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {this.renderOptions()}
        </Select>
      </Spin>
    )
  }
}

UserSwitch.propTypes = propTypes
export default UserSwitch



// WEBPACK FOOTER //
// ./src/containers/dashboard/UserSwitch.js